import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { fromJS } from 'immutable'

@Component({
  selector: 'payment-card',
  templateUrl: './payment-card.component.html',
  styleUrls: ['./payment-card.component.css'],
})
export class PaymentCardComponent implements OnInit {
  @Input() public payment: any
  @Input() public currency: any
  @Input() public open: boolean
  @Input() public hasType: boolean
  @Input() public isCurrentCycle: boolean
  @Input() public readonly: boolean
  @Input() public isPaymentDownloading: boolean
  @Output() onCreatePayment: EventEmitter<any> = new EventEmitter()
  @Output() onUpdatePayment: EventEmitter<any> = new EventEmitter()
  @Output() onDeletePayment: EventEmitter<any> = new EventEmitter()
  @Output() onDownloadPayment: EventEmitter<any> = new EventEmitter()
  @Output() onClose: EventEmitter<any> = new EventEmitter()
  @Output() onOpen: EventEmitter<any> = new EventEmitter()
  public payments = fromJS([])
  public columns = [
    {
      prop: 'amount',
      name: 'AMOUNT',
      template: 'tax',
    },
    {
      prop: 'id',
      name: 'MOPTAX_ID',
    },
    {
      prop: 'transactionId',
      name: 'BANK_ID',
      template: 'transactionId',
    },
    {
      prop: 'notes',
      name: 'NOTES',
      template: 'notes',
    },
    {
      prop: 'paymentDate',
      name: 'PAYMENT_DATE',
      template: 'paymentDate',
    },
    {
      prop: 'actions',
      template: 'actions',
    },
  ]

  constructor() {}

  getBalanceColor(row: any) {
    if (row.balance.balance < 0 && row.balance.totalPayed == 0) return '#fddad2'
    if (row.balance.balance < 0 && row.balance.totalPayed > 0) return '#f5eed4'

    return '#d9eedc'
  }

  ngOnInit() {
    this.payments = fromJS(this.payment.payments)
  }
}
